import React from "react";
import GuranteeBadge from "../../../assets/90-guaranteed.png"

const Gurantee = () => {
    return (
        <div className="px-6"
        >
            <div className="max-w-4xl mx-auto relative mt-20   bg-[#f7f6f4] border-black border-8 ">
                <div className="flex flex-col items-center text-center  z-10">
                    {/* <!-- Money Back Seal --> */}
                    <div className="md:w-72 md:h-72 md:-mt-32 -mt-20  w-36 h-36  flex justify-center">
                        <img
                            src={GuranteeBadge}
                            alt="100% Money Back Guarantee Seal"
                            className="w-full h-full object-contain hover:rotate-2 duration-300 ease-in-out hover:opacity-90"
                        />
                    </div>
                    {/* <!-- Headings --> */}
                    <h2 className="md:text-4xl text-2xl font-bold text-gray-900 mb-2">
                        100% Satisfaction
                    </h2>
                    <h3 className="md:text-5xl sm:text-2xl text-xl font-bold text-[#FF1300] mb-6">
                        180-Day Money Back Guarantee
                    </h3>
                    {/* <!-- Description --> */}
                    <p className="max-w-3xl text-gray-800 mb-10 text-lg leading-6 font-light">
                        Your order today is protected by my iron-clad 180-day 100% money-back guarantee. If you are not astonished how fast mucus build-up and breathlessness is eliminated, or shocked as you admire your new life, then at any time in the next 90 days let us know and we'll refund every single penny of your investment. No questions asked.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Gurantee;
